module.exports = {
	"postTitle": {
		"cs-CZ": "jarní koncert 2025",
		"en-GB": "spring concert 2025",
		"fr-FR": "concert de printemps 2025",
		"de-DE": "Frühlingskonzert 2025"
	},
	"text01": {
		"cs-CZ": "Musica pro Sancta Cecilia vás zve na svůj červnový, stále ještě jarní koncert. Na programu tentokrát bude hudební putování renezancí a barokem.",
		"en-GB": "Musica pro Sancta Cecilia invites you to its June concert, still in spring. The programme this time will be a musical journey through the Renaissance and Baroque.",
		"fr-FR": "Musica pro Sancta Cecilia vous invite à son concert de juin, toujours au printemps. Le programme sera cette fois un voyage musical à travers la Renaissance et le Baroque.",
		"de-DE": "Musica pro Sancta Cecilia lädt Sie zu seinem Juni-Konzert ein, noch im Frühling. Das Programm wird dieses Mal eine musikalische Reise durch die Renaissance und den Barock sein."
	},
	"text02": {
		"cs-CZ": "Sobota 14. 06. 2025 v 17 hodin v kostele sv. Michala v Jirchářích (v blízkosti stanice Národní třída - tram. č. 2, 9, 18, 22 - metro trasa B).",
		"en-GB": "Saturday 14 June 2025 at 5 pm at the Church of St. Michala v Jirchářích (near the Národní třída station - trams 2, 9, 18, 22 - metro line B).",
		"fr-FR": "Samedi 14 juin 2025 à 17 heures à l'église Saint-Michala v Jirchářích (près de la station Národní třída - trams 2, 9, 18, 22 - métro ligne B).",
		"de-DE": "Samstag, 14. Juni 2025 um 17 Uhr in der Kirche St. Michala v Jirchářích (in der Nähe der Haltestelle Národní třída - Straßenbahnlinien 2, 9, 18, 22 - U-Bahnlinie B)."
	},
	"text03": {
		"cs-CZ": "Vstupné je dobrovolné.",
		"en-GB": "The entrance fee is voluntary.",
		"fr-FR": "L'entrée est volontaire.",
		"de-DE": "Der Eintritt ist freiwillig."
	},
	"text04": {
		"cs-CZ": "Koncert bude přenášen na: ",
		"en-GB": "The concert will be streamed on:",
		"fr-FR": "Le concert sera retransmis en streaming sur :",
		"de-DE": "Das Konzert wird im Internet übertragen:"
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/post05/Post05.json
// module id = 89
// module chunks = 0